import { api } from "./api";

// Shared, cached location lookups (state/district/lsgd/ward) so pages don't
// refetch the full list and one slow call never blanks the dropdowns.
let cache = null;
let at = 0;
const TTL = 5 * 60 * 1000;

export function getLocations() {
  if (cache && Date.now() - at < TTL) return cache;
  at = Date.now();
  cache = Promise.all(["state", "district", "lsgd", "ward"].map(t =>
    api.get("/locations", { params: { type: t }, timeout: 45000 }).then(r => r.data || [])))
    .then(parts => parts.flat())
    .catch(e => { cache = null; throw e; });
  return cache;
}

export const invalidateLocations = () => { cache = null; };

// Drop-in for Promise.all members: resolves to { data } and never rejects.
export const safe = (p, fallback = []) => p.catch(() => ({ data: fallback }));
export const locationsRes = () => getLocations().then(data => ({ data })).catch(() => ({ data: [] }));
